import { render, staticRenderFns } from "./Bindwallet.vue?vue&type=template&id=d46e518a&scoped=true&"
import script from "./Bindwallet.vue?vue&type=script&lang=js&"
export * from "./Bindwallet.vue?vue&type=script&lang=js&"
import style0 from "./Bindwallet.vue?vue&type=style&index=0&id=d46e518a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d46e518a",
  null
  
)

export default component.exports